import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/pro-duotone-svg-icons';
import HeaderComponent from './HeaderComponent';
import FeatureNav from './FeatureNav';
import BreadCrumbs from './BreadCrumbs';
import FooterSection from './FooterSection';
import JobTitleHighestPaid from "../assets/images/job_title_highest_paid.svg";
import JobTitleCommon from "../assets/images/job_title_common.svg";
import JobTitleLG from "../assets/images/job_title_lg.svg";
import JobTitleWageTrends from "../assets/images/job_title_wage_trends.svg";
import JobTitleCompare from "../assets/images/job_title_compare.svg";
import JobTitleSearch from "../assets/images/job_title_search.svg";
import '../assets/styles/main.css';

const JobTitleCompensation = () => {
  return (
    <div className="job-title-compensation" id="job-title-compensation">
        <HeaderComponent/>
        <FeatureNav />
        <BreadCrumbs/>
        <section className="mt-20">
          <div className="text-center mb-4">
              <h1 className="display-5 fw-bold mb-3">Job Title Compensation</h1>
          </div>
          <div className="jumbotron border text-light rounded my-4 mx-4 pt-3 pb-0 border shadow px-0" style={{ backgroundColor: "var(--tu-teal)"}}>
              <div className="col-12 py-2 rounded" style={{ paddingLeft: "15px"}}>
              <h3 className="text-light">
                  <FontAwesomeIcon icon={faBriefcase} />
                  Job Title Compensation
              </h3>
              <p className="lead">Use these tools to compare compensation by Job Title or Occupation</p>
              </div>

              <div className="col-12 bg-light ">
                  <div className="row justify-content-center px-3 text-dark">
                    <article className="col-auto py-3">
                      <a className="card mb-4 box-shadow h-100" target="_blank" 
                      rel="noopener noreferrer" href="/employees/highest-paid-jobs" title="Highest Paid">
                        <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Highest Paid</div>
                        <img className="card-img-top" alt="Discover the highest paying jobs and occupations" src={JobTitleHighestPaid} data-holder-rendered="true"/>
                        <div className="card-body py-0">
                          <p className="card-text text-center">Discover the highest paying jobs and occupations</p>
                        </div>
                      </a>
                    </article>

                    <article className="col-auto py-3">
                      <a className="card mb-4 box-shadow h-100" target="_blank" 
                      rel="noopener noreferrer" href="/employees/most-common-jobs" title="Most Common Jobs">
                        <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Most Common</div>
                        <img className="card-img-top" alt="Most Common" src={JobTitleCommon} data-holder-rendered="true"/>
                        <div className="card-body py-0">
                          <p className="card-text text-center">Examine a curated dataset of the most common jobs in Utah</p>
                        </div>
                      </a>
                    </article>

                    <article className="col-auto py-3">
                      <a className="card mb-4 box-shadow h-100" target="_blank" 
                      rel="noopener noreferrer" href="/employees/local-government-jobs" title="Local Government Jobs">
                        <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Local Government</div>
                        <img className="card-img-top" alt="Local Government" src={JobTitleLG} data-holder-rendered="true"/>
                        <div className="card-body py-0">
                          <p className="card-text text-center">Find out the compensation packages for local government jobs</p>
                        </div>
                      </a>
                    </article>

                    <article className="col-auto py-3">
                      <a className="card mb-4 box-shadow h-100" target="_blank" 
                      rel="noopener noreferrer" href="/employees/job-title-wage-trends" title="Wage Trends">
                        <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Wage Trends</div>
                        <img className="card-img-top" alt="Wage Trends" src={JobTitleWageTrends} data-holder-rendered="true"/>
                        <div className="card-body py-0">
                          <p className="card-text text-center">Examine wage trends and analytics across time for a given occupation</p>
                        </div>
                      </a>
                    </article>

                    <article className="col-auto py-3">
                      <a className="card mb-4 box-shadow h-100" target="_blank" 
                      rel="noopener noreferrer" href="https://old.transparent.utah.gov/job_title_compare.php" title="Compare Two Entities">
                        <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Compare Two Entities</div>
                        <img className="card-img-top" alt="Compare Two Entities" src={JobTitleCompare} data-holder-rendered="true"/>
                        <div className="card-body py-0">
                          <p className="card-text text-center">Compare and contrast two entity's compensation data side by side</p>
                        </div>
                      </a>
                    </article>

                    <article className="col-auto py-3">
                      <a className="card mb-4 box-shadow h-100" target="_blank" 
                      rel="noopener noreferrer" href="/employees/job-title-search" title="Custom Search">
                        <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Custom Search</div>
                        <img className="card-img-top" alt="Custom Search" src={JobTitleSearch} data-holder-rendered="true"/>
                        <div className="card-body py-0">
                        <p className="card-text text-center">Search across utah job titles using a custom search term. Size Limits apply.</p>
                        </div>
                      </a>
                    </article>
                  </div>
              </div>
          </div>
        </section>
        <FooterSection />
    </div>
  )
}

export default JobTitleCompensation;